import script from "./HeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=cb725862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb725862"]])

export default __exports__